import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.pl.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
import { mount } from '../dom-lifecycle';
import { mountRuleValidator } from './validation';
import { validatePolish } from 'validate-polish';
import IBAN from 'iban';
import IMask from 'imask';
import './files';
import './prize-variant';

$.fn.datepicker.defaults.language = "pl";
$.fn.datepicker.defaults.format = "dd.mm.yyyy";
$.fn.datepicker.defaults.clearBtn = true;
$.fn.datepicker.defaults.defaultViewDate = new Date();
$.fn.datepicker.defaults.maxViewMode = 'decade';
$.fn.datepicker.dates.pl.monthsTitle = 'Miesiące';

mount('input[data-type=datepicker]', el => {
	const $el = $(el).datepicker({ keyboardNavigation: false });

	// Ręczne wpisywanie: maska daty dd.mm.yyyy — auto-kropki, blokuje niemożliwe dni/miesiące
	// i daty spoza zakresu (max = dziś, min = 120 lat wstecz). Kalendarz działa jak dotąd.
	const max = new Date();
	const min = new Date(max.getFullYear() - 120, max.getMonth(), max.getDate());
	const mask = new IMask(el, {
		mask: Date,
		pattern: 'd{.}`m{.}`Y',
		lazy: true,
		overwrite: true,
		min,
		max,
	});

	// Wybór z kalendarza / reset formularza → zsynchronizuj wartość maski.
	$el.on('changeDate clearDate', () => { mask.value = $el.val(); });
	$(el.form).on('reset', () => { mask.value = ''; });
});

// Data bez kalendarza: sama maska dd.mm.rrrr — auto-kropki, blokuje niemożliwe dni/miesiące
// i daty spoza zakresu (max = dziś, min = 120 lat wstecz).
mount('input[data-type=datemask]', el => {
	const max = new Date();
	const min = new Date(max.getFullYear() - 120, max.getMonth(), max.getDate());
	const mask = new IMask(el, {
		mask: Date,
		pattern: 'd{.}`m{.}`Y',
		lazy: true,
		overwrite: true,
		min,
		max,
	});

	$(el.form).on('reset', () => { mask.value = ''; });
});

mountRuleValidator('input[data-type=pesel]', 'pesel', input => validatePolish.pesel(input.value));
mountRuleValidator('input[data-type=nip]', 'nip', input => validatePolish.nip(input.value));
mountRuleValidator('input[data-type=iban]', 'iban', input => IBAN.isValid(input.value));
